import { Link } from "react-router-dom";
import { Reveal } from "@/pages/designPreview/previewMotion";

const ITEMS = [
  { href: "/design-preview/capabilities", label: "Capabilities" },
  { href: "/design-preview/authority", label: "Authority" },
  { href: "/design-preview/guides", label: "Guide Hub" },
  { href: "/design-preview/guide-detail", label: "Guide Detail" },
];

export default function PreviewIndex() {
  return (
    <div className="dp-index-home">
      <Reveal>
        <p className="dp-kicker">DESIGN PREVIEW</p>
        <h1 className="dp-display">Scenes, not documents.</h1>
      </Reveal>
      <nav style={{ marginTop: "3rem" }}>
        {ITEMS.map((row) => (
          <Link key={row.href} to={row.href}>{row.label}</Link>
        ))}
      </nav>
    </div>
  );
}
